import { render, staticRenderFns } from "./LandingSubtitle.vue?vue&type=template&id=5ffaa26f&scoped=true"
import script from "./LandingSubtitle.vue?vue&type=script&lang=js"
export * from "./LandingSubtitle.vue?vue&type=script&lang=js"
import style0 from "./LandingSubtitle.vue?vue&type=style&index=0&id=5ffaa26f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffaa26f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffaa26f')) {
      api.createRecord('5ffaa26f', component.options)
    } else {
      api.reload('5ffaa26f', component.options)
    }
    module.hot.accept("./LandingSubtitle.vue?vue&type=template&id=5ffaa26f&scoped=true", function () {
      api.rerender('5ffaa26f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingSubtitle.vue"
export default component.exports